export default "__VITE_ASSET__BaV37iJo__"